export enum SegmentType {
  'EMPTY' = 'EMPTY',
  'IMAGE' = 'IMAGE',
  'AUDIO' = 'AUDIO',
  'VIDEO' = 'VIDEO',
  'COMPOSITE' = 'COMPOSITE'
}
